export enum AllUserRoles {
    ZENTIVA_CORPORATE = 'ZENTIVA_CORPORATE',
    ZENTIVA_SALES = 'ZENTIVA_SALES',
    HVS_USER = 'HVS_USER',
    HVS_SUPERVISOR = 'HVS_SUPERVISOR'
}
